import { createSlice } from '@reduxjs/toolkit';
import { RecalculationMode, RecalculationStatus } from 'types/recalculation';

export interface IRecalculationGeneralInfo {
  mode: RecalculationMode;
  startDate: string;
  endDate: string;
}

export interface IRecalculationDryRun {
  data?: {
    incorrectPaymentsNumber: number;
    incorrectPaymentsTotalNumber: number;
    correctPaymentsNumber: number;
    correctPaymentsTotalNumber: number;
  };

  error?: string | null;
  status: RecalculationStatus;
}

export interface IRecalculationHardRun {
  error?: string | null;
  status: RecalculationStatus;
}

interface RecalculationState {
  taskId: string | null;
  generalInfo: IRecalculationGeneralInfo | null;
  dryRun: IRecalculationDryRun | null;
  hardRun: IRecalculationHardRun | null;
}

const initialState: RecalculationState = {
  taskId: null,
  generalInfo: null,
  dryRun: null,
  hardRun: null,
};

export const recalculationSlice = createSlice({
  name: 'recalculation',
  initialState,
  reducers: {
    resetRecalculation: state => {
      state.taskId = null;
      state.generalInfo = null;
      state.dryRun = null;
      state.hardRun = null;
    },

    setRecalculationGeneralInfo: (state, action) => {
      state.generalInfo = action.payload;
    },

    setRecalculationTaskId: (state, action) => {
      state.taskId = action.payload;
    },

    setRecalculationDryRun: (state, action) => {
      state.dryRun = action.payload;
    },

    setRecalculationHardRun: (state, action) => {
      state.hardRun = action.payload;
    },
  },
});

export const {
  resetRecalculation,
  setRecalculationGeneralInfo,
  setRecalculationTaskId,
  setRecalculationDryRun,
  setRecalculationHardRun,
} = recalculationSlice.actions;

export default recalculationSlice.reducer;
